import { Component, ElementRef, ViewChild, Input } from '@angular/core';
import { AbstractComponent } from 'src/core/common/component/AbstractComponent';

import Hls from "hls.js";
import { GSVideoService } from './GSVideoService';
import { Socket } from 'ngx-socket-io';

import moment from 'moment';

declare var vis;
@Component({
  selector: 'gs-video',
  templateUrl: './GSVideo.html',
  styleUrls: ['./GSVideo.scss'],
})
export class GSVideoComponent extends AbstractComponent {

  public _el;

  @ViewChild('camera', {static: true}) 
  public target: ElementRef;

  @ViewChild('timeline', {static: true}) 
  public timeline: ElementRef;

  @ViewChild('canvas', {static: true}) 
  public canvas: ElementRef;

  @Input()
  public id = ''

  @Input()
  public info;

  public interval;
  public timeInterval;
  public selectedDay;
  public detectedObj;
  public filePath;
  public detectionTimes = [];
  public scope = {
    title : '',
    scope : '',
    image : '',
    videoUrl : {},
    autoMove : true,
    videoWidth : 0,
    videoHeight : 0,
    currentTime : '',
    hover : false,
    isPlay : false,
    isLive : false,
    rate : "1.0",
  }

  public infoScope = {
    id : '',
    name : '',
    description : '',
    hour : 0,
  }

  /** canvas */
  public canvasEventScope = {
    imageScale : 1, 
    imageScaleIndex : 0,
    mouseX : 0,
    mouseY : 0,
    press : false,
    mouseMoveX : 0,
    mouseMoveY : 0,
    mouseDragX : 0, 
    mouseDragY : 0,
    zoomWidth : 0, 
    zoomHeight : 0, 
    zoomLeft : 0, 
    zoomTop : 0,
    zoomLeftBuf : 0,
    zoomTopBuf : 0
  }
 
  /** week */
  public week = {
    date: 0,
    wDay: [],
    class: [],
    wDate: [],
    month: []
  }
  public visTimeline;
  public constructor(
    el: ElementRef,
    private socket: Socket, 
    private service: GSVideoService) {
    super();
    this._el = el.nativeElement;
  }

  public componentWillMount() {
    let now = moment();
    let startTime = moment(now).add(-30, 'm');
    let endTime = moment(now).add(30, 'm');
    var options = {
      editable: false,
      // zoomable : false,
      zoomMin : 10000,
      zoomMax : 100000000,
      start: startTime.toDate(),
      end : endTime.toDate(),
      onMove : (e) => {
        console.log(e)
      },
      // always snap to full hours, independent of the scale
      snap: (date, scale, step) => {
        let hour = 60 * 60 ;
        return Math.round(date / hour) * hour;
      },
      stack : false
    };
    let container = this.timeline.nativeElement;

    this.filePath = this.service.thumbnail(this.id);

    this.infoScope.id = this.info.streamId;
    this.infoScope.name = this.info.streamName;
    this.infoScope.description = this.info.description;
    this.infoScope.hour = this.info.dataRetentionInHours;

    this.service.get(this.id).subscribe((video:any) => {
      this.scope.title = video.video.name;
      this.scope.videoUrl = {
        src : video.url.HLSStreamingSessionURL,
        type: 'application/x-mpegURL'
      }
      let num = 1;
      let itemNum = 1;
      let dataSet = [];
      let items = [];
      for (let timeKey of Object.keys(video.times)) {
        let key = timeKey.split('_')[0];
        if (!dataSet.find(e => e.content == key)) {
          dataSet.push({ id: num++, content: key });
        }
        let data = dataSet.find(e => e.content == key);
        items.push({
          id : itemNum++,
          group : data.id, 
          content: key, 
          start: video.times[timeKey].start,
          end: video.times[timeKey].end
        });
        this.detectionTimes.push(
          video.times[timeKey].start
        );
      }      
      let groups = new vis.DataSet(dataSet);
      let visItems = new vis.DataSet(items);
      this.visTimeline = new vis.Timeline(container, visItems, groups, options);
      this.scope.isLive = true;
      this.scope.rate = "1.0";

      let loading = document.getElementById("nb-global-spinner");
      loading.style.visibility = "visible";

      this.loadSource(video.url.HLSStreamingSessionURL).then(() => {

        this.visTimeline.on('rangechange', (event) => {

          let s = moment(event.start).add(5, 'm');
          let e = moment(event.end).add(-5, 'm');
          this.scope.autoMove = moment(this.visTimeline.getCurrentTime()).isBetween(s, e);
        });

        this.visTimeline.on('click', (event) => {

          loading.style.visibility = "visible";
          let now = moment().add(-30, 's');

          if (now.isAfter(moment(new Date(event.time)))) {
            now = moment(new Date(event.time));
            this.scope.isLive = false;
          } else {
            this.scope.isLive = true;
            this.scope.rate = "1.0";
          }

          this.service.get(this.id, now.toDate()).subscribe((video:any) => {

            this.scope.videoUrl = {
              src : video.url.HLSStreamingSessionURL,
              type: 'application/x-mpegURL'
            }

            this.loadSource(video.url.HLSStreamingSessionURL).then();
            video.playbackRate = parseFloat(this.scope.rate);
            video.defaultPlaybackRate = parseFloat(this.scope.rate);
            loading.style.visibility = "hidden";
          });

          this.visTimeline.setCurrentTime(now.toDate());
          this.scope.currentTime = moment(this.visTimeline.getCurrentTime()).format("MM/DD HH:mm:ss");
          this.scope.autoMove = true;
        });
      });

      this.detectedObj = items;

      // 重なったカーソルが離れた
      this.visTimeline.on('itemout', (event) => {
        let tooltip = document.getElementById("popupThumbnail");
        tooltip.style.visibility = "hidden";
      });
  
      // 各アイテムの上にカーソルが重なった
      this.visTimeline.on('itemover', (event) => {
  
        let tooltip = document.getElementById("popupThumbnail");
        tooltip.style.visibility = "visible";
  
        // カーソルと同じ位置に表示されると見づらいため補正
        let width = tooltip.getBoundingClientRect().width;
        let height = tooltip.getBoundingClientRect().height;
        var xPos = event.event.pageX - width * 1.5;
        var yPos = event.event.pageY - height * 2;
  
        tooltip.style.top = yPos + "px";
        tooltip.style.left = xPos + "px";
  
        var video : HTMLSourceElement = <HTMLSourceElement>document.getElementById("popupThumbnail");
        video.src = this.filePath + this.detectedObj[event.item - 1].start;    
      });

      this.detectionTimes.sort()
      this.detectionTimes = Array.from(new Set(this.detectionTimes));
    });

    this.getWeek();
  }

  public componentDidMount() {
    var btn_close = document.getElementById('close');

    btn_close.addEventListener('click', function() {
      const modal = document.querySelector('dialog');
      modal.close();
    }, false);
  }
  
  public openDialog() {
    const modal = document.querySelector('dialog');
    modal.showModal();
  }

  /** 動画読み込み */
  public loadSource(url) {
    return new Promise((resolve) => {
      if (this.interval) {
        clearInterval(this.interval);
      }
      let video = this.target.nativeElement;
      const hls = new Hls();
      hls.loadSource(url);
      hls.attachMedia(this.target.nativeElement);
      hls.on(Hls.Events.MEDIA_ATTACHED, () => {
        video.style.display = "block";
        video.muted = true;
        video.play();
        this.scope.isPlay = true;
        hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {});
        let canvas = this.canvas.nativeElement;
        let ctx = canvas.getContext("2d");
        let loading = document.getElementById("nb-global-spinner");
        loading.style.visibility = "hidden";

        this.intervalFPS();
        setTimeout(() => {
          resolve(true);
          loading.style.visibility = "hidden";
        }, 100);

      });
    });
  }

  public paly() {
    if (this.scope.isPlay) {
      this.target.nativeElement.pause();
    } else {
      this.target.nativeElement.play();
    }
    this.scope.isPlay = !this.scope.isPlay;
  }

  public playbackRate() {
    let video = this.target.nativeElement;
    video.playbackRate = parseFloat(this.scope.rate);
    video.defaultPlaybackRate = parseFloat(this.scope.rate); 
    this.intervalFPS();
  }

  public intervalFPS() {    
    console.log('intervalFPS');
    let video = this.target.nativeElement;
    let canvas = this.canvas.nativeElement;
    let ctx = canvas.getContext("2d");

    this.interval = setInterval(() => {
      if (this.scope.videoWidth == 0) {
        this.scope.videoWidth = video.videoWidth;
        this.scope.videoHeight = video.videoHeight;  
      }
      ctx.drawImage(video, this.canvasEventScope.zoomLeft, this.canvasEventScope.zoomTop, this.scope.videoWidth  / this.canvasEventScope.imageScale, this.scope.videoHeight / this.canvasEventScope.imageScale, 0, 0, this.scope.videoWidth, this.scope.videoHeight);
    }, 1000/ 60 * parseFloat(this.scope.rate));
    this.timeInterval = setInterval(() => {
      if (this.scope.isPlay) {
        if (this.scope.autoMove) {
          let m = moment(this.visTimeline.getCurrentTime()).add(parseFloat(this.scope.rate), 's');
          this.visTimeline.moveTo(m.toDate());
          this.scope.currentTime = m.format("MM/DD HH:mm:ss");
        }  
      }
    }, 1000);
  }
  /**
   * ボタンクリック
   * @param n time
   */
  public moveTo(n) {
    let now = moment().add(60, 's');
    let loading = document.getElementById("nb-global-spinner");
    loading.style.visibility = "visible";
    if (n != 0) {
      if (moment(this.visTimeline.getCurrentTime()).isBefore(now)) {
        now = moment(this.visTimeline.getCurrentTime())
        now = moment(now).add(n, 'm');
        this.scope.isLive = false;
      } else {
        this.scope.isLive = true;
        this.scope.rate = "1.0";
      }
    } else {
      this.scope.isLive = true;
    }
    this.service.get(this.id, n != 0 ? now.toDate() : null).subscribe((video:any) => {
      this.scope.videoUrl = {
        src : video.url.HLSStreamingSessionURL,
        type: 'application/x-mpegURL'
      }
      this.loadSource(video.url.HLSStreamingSessionURL).then();
      video.playbackRate = parseFloat(this.scope.rate);
      video.defaultPlaybackRate = parseFloat(this.scope.rate);
      this.visTimeline.setCurrentTime(now.toDate())
      this.visTimeline.moveTo(now.toDate());  
    });
  }

  /**
   * スケール変更
   * @param n scale
   */
  public changeScale(n) {
    let s = moment(this.visTimeline.getCurrentTime()).add(-n, 'm');
    let e = moment(this.visTimeline.getCurrentTime()).add(n, 'm');
    var options = {
      start: s.toDate(),
      end : e.toDate()
    };
    this.visTimeline.setOptions(options);
  }

  /**
   * 直近1週間の日付、曜日を取得
   */
  public getWeek() {
    this.week.date = new Date().getDate();
    // 曜日の配列
    const weekChars = [ "日", "月", "火", "水", "木", "金", "土" ];
    
    // 曜日の取得
    let today = new Date();
    let weekDay = today.getDay();
    for (let i = 0; i < 7; i++) {
      // 遡って日曜日より前の場合の対応
      if (weekDay - i < 0) {
        weekDay = weekDay + 7;
      }

      let date = new Date();
      date.setDate(date.getDate() - i);
      let isInsert: boolean = false
      let month: any = date.getMonth() + 1

      if (this.week.wDate.length > 0) {

        // 一つ前の日付と月が異なっていたら「月/日」みたいな感じにする
        if (this.week.month[i - 1] != month) {
          isInsert = true
          this.week.wDate.push(month + "/" + date.getDate());
        }
      }
      else {
        isInsert = true
        this.week.wDate.push("今日");
      }

      if (!isInsert) {
        this.week.wDate.push(date.getDate());
      }

      this.week.month.push(month);

      this.week.wDay.push(weekChars[weekDay - i]);
      if (weekChars[weekDay - i] == "土") {
        this.week.class.push("saturday");
      } else if (weekChars[weekDay - i] == "日") {
        this.week.class.push("sunday");
      } else {
        this.week.class.push("weekdays");
      }
    }
  }

  /**
   * 選択した日付にシフトする
   * @param n day
   */
  public moveDays(n) {
    let loading = document.getElementById("nb-global-spinner");
    loading.style.visibility = "visible";
    let now = moment().add(-60, 's');
    if (n != 0) {
      now = moment(now).add(-n, 'd');
      this.scope.isLive = false;
    } else {
      this.scope.isLive = true;
    }
    this.service.get(this.id, n != 0 ? now.toDate() : null).subscribe((video:any) => {
      this.scope.videoUrl = {
        src : video.url.HLSStreamingSessionURL,
        type: 'application/x-mpegURL'
      }
      this.loadSource(video.url.HLSStreamingSessionURL).then();
      video.playbackRate = parseFloat(this.scope.rate);
      video.defaultPlaybackRate = parseFloat(this.scope.rate);
      this.visTimeline.setCurrentTime(now.toDate())
      this.visTimeline.moveTo(now.toDate());  
    });
  }

  /**
   * カレンダーから選択した日付にシフトする
   * @param n day
   */
   public selectedCalendar(n) {
    let loading = document.getElementById("nb-global-spinner");
    loading.style.visibility = "visible";
    let now = moment().add(-60, 's');
    let dayBefore = this.visTimeline.getCurrentTime();
    let dayAfter = this.selectedDay;
    let termDay = (dayAfter - dayBefore) / 86400000;
    if (termDay != 0) {
      now = moment(this.visTimeline.getCurrentTime()).add(Math.ceil(termDay), 'd');
    }
    this.service.get(this.id, n != 0 ? now.toDate() : null).subscribe((video:any) => {
      this.scope.videoUrl = {
        src : video.url.HLSStreamingSessionURL,
        type: 'application/x-mpegURL'
      }
      this.loadSource(video.url.HLSStreamingSessionURL).then();
      video.playbackRate = parseFloat(this.scope.rate);
      video.defaultPlaybackRate = parseFloat(this.scope.rate);
      this.visTimeline.setCurrentTime(now.toDate())
      this.visTimeline.moveTo(now.toDate());  
    });
  }

  /**
   * 前後の検出物にシフトする
   * @param n 前後
   */
  public skipVideo(n) {
    let loading = document.getElementById("nb-global-spinner");
    loading.style.visibility = "visible";
    // 選択中の時刻の取得
    let now = moment(this.visTimeline.getCurrentTime());
    // 次の検知時刻の取得
    let today = new Date();
    let nextTime;
    let nextObj = "";
    if (n == "next") {
      nextTime = moment(today);
      for (let i = 0; i < this.detectedObj.length; i++) {
        if (now < moment(this.detectedObj[i].start) && moment(this.detectedObj[i].start) < nextTime && nextObj != this.detectedObj[i].content) {
          nextTime = moment(this.detectedObj[i].start);
          nextObj = this.detectedObj[i].content;
        }
      }
    } else if (n == "prev") {
      nextTime = new Date(1970, 1, 1);
      for (let i = this.detectedObj.length - 1; i >= 0; i--) {
        if (now.seconds(0) > moment(this.detectedObj[i].start) && moment(this.detectedObj[i].start) > nextTime) {
          nextTime = moment(this.detectedObj[i].start);
          nextObj = this.detectedObj[i].content;
        }
      }

      if (nextObj != "") {
        this.scope.isLive = false;
      }
    }
    this.service.get(this.id, n != 0 ? nextTime.toDate() : null).subscribe((video:any) => {
      this.scope.videoUrl = {
        src : video.url.HLSStreamingSessionURL,
        type: 'application/x-mpegURL'
      }
      this.loadSource(video.url.HLSStreamingSessionURL).then();
      video.playbackRate = parseFloat(this.scope.rate);
      video.defaultPlaybackRate = parseFloat(this.scope.rate);
      this.visTimeline.setCurrentTime(moment(nextTime));
      this.visTimeline.moveTo(moment(nextTime));  
    });
  }

  public skipThumb(time){
    let loading = document.getElementById("nb-global-spinner");
    loading.style.visibility = "visible";
    console.log(time);
    let now = moment(time);
    this.service.get(this.id, now.toDate()).subscribe((video:any) => {
      this.scope.videoUrl = {
        src : video.url.HLSStreamingSessionURL,
        type: 'application/x-mpegURL'
      }
      this.loadSource(video.url.HLSStreamingSessionURL).then();
      video.playbackRate = parseFloat(this.scope.rate);
      video.defaultPlaybackRate = parseFloat(this.scope.rate);
      this.visTimeline.setCurrentTime(moment(now));
      this.visTimeline.moveTo(moment(now));
      this.scope.isLive = false;
    });
  }
  ////// event 
  
  public changeZoom() {
    if (this.canvasEventScope.imageScale == 1) {
      this.canvasEventScope.zoomWidth = this.scope.videoWidth;
      this.canvasEventScope.zoomHeight = this.scope.videoHeight;
      this.canvasEventScope.zoomLeft = 0;
      this.canvasEventScope.zoomTop = 0;
    } else {
      this.canvasEventScope.zoomWidth = this.scope.videoWidth   / this.canvasEventScope.imageScale;
      this.canvasEventScope.zoomHeight = this.scope.videoHeight / this.canvasEventScope.imageScale;
    }
  }
  public mouseover(e) {
    this.scope.hover = true;
  }
  public mouseout(e) {
    this.scope.hover = false;
  }

  public mousedown(e) {
    this.canvasEventScope.press = true;
    this.canvasEventScope.zoomLeftBuf = this.canvasEventScope.zoomLeft;
    this.canvasEventScope.zoomTopBuf  = this.canvasEventScope.zoomTop;
  }
  public mouseup(e) {
    this.canvasEventScope.press = false;
  }

  public mouseMove(e) {
    if (this.canvasEventScope.imageScale != 1) {
      let rect = e.target.getBoundingClientRect();
      if (this.canvasEventScope.press) {
        this.canvasEventScope.mouseDragX = e.clientX - rect.left;
        this.canvasEventScope.mouseDragY = e.clientY - rect.top;
        this.canvasEventScope.zoomLeft = this.canvasEventScope.zoomLeftBuf + (this.canvasEventScope.mouseMoveX - this.canvasEventScope.mouseDragX) / this.canvasEventScope.imageScale;
        this.canvasEventScope.zoomTop = this.canvasEventScope.zoomTopBuf + (this.canvasEventScope.mouseMoveY - this.canvasEventScope.mouseDragY) / this.canvasEventScope.imageScale;
        this.canvasEventScope.zoomLeft = Math.max(0, Math.min(this.scope.videoWidth -  this.canvasEventScope.zoomWidth, this.canvasEventScope.zoomLeft));
        this.canvasEventScope.zoomTop  = Math.max(0, Math.min(this.scope.videoHeight - this.canvasEventScope.zoomHeight, this.canvasEventScope.zoomTop));
      } else {
        this.canvasEventScope.mouseMoveX = e.clientX - rect.left;
        this.canvasEventScope.mouseMoveY = e.clientY - rect.top;    
      }
    }
  }



}
